export default __webpack_public_path__ + "static/media/Banner-resena-1-agenda.9241abb8.jpg";